import { render, staticRenderFns } from "./UserTeams.vue?vue&type=template&id=5dbd297f"
import script from "./UserTeams.js?vue&type=script&lang=js&external"
export * from "./UserTeams.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports